import { find } from 'linkifyjs'

type FindMatchLinkify = {
  type: string
  value: string
  isLink: boolean
  href: string
  start: number
  end: number
}
export const findUrl = (text: string): FindMatchLinkify[] => find(text)
